(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oficial-service"] && !window.DesignMode) return;
  try {
    


  
// Define your locations: HTML content for the info window, latitude, longitude
    var locations = [
      ['<div><div class="name">EPSH LLC</div><div class="address"><strong>Address: </strong>2741 Crown Hill, Eagle Pass<a target="_blank" href="https://www.google.com/maps/dir/?api=1&amp;destination=(28.732854948714, -100.47934915582407)" tabindex="0">How to get</a></div><div class="telephone"><strong>Telephone: </strong><a href="tel:+18303526186">(830) 352-6186</a></div></div>', 28.732854948714, -100.47934915582407],
      ['<div><div class="name">Mobile Service</div><div class="address"><strong>Address: </strong>20727 US-77 BUS, Harlingen, Texas 78552</div><div class="telephone"><strong>Telephone: </strong><a href="tel:+18328310611">(832) 831-0611</a></div></div>', 26.259671342953247, -97.73266967116481],
      ['<div><div class="name">Gondi Logistics LLC</div><div class="address"><strong>Address: </strong>407 Interamerica, Laredo, Texas 78045<a target="_blank" href="https://www.google.com/maps/dir/?api=1&amp;destination=(27.617089387160682, -99.52919223064761)" tabindex="0">How to get</a></div><div class="telephone"><strong>Telephone: </strong><a href="tel:+12103006833">(210) 300-6833</a></div></div>', 27.617089387160682, -99.52919223064761],
      ['<div><div class="name">COLVEN USA LLC</div><div class="address"><strong>Address: </strong>6120, N Shepherd Dr Houston, TX 77091<a target="_blank" href="https://www.google.com/maps/dir/?api=1&amp;destination=(29.853986159723345, -95.41149368845207)" tabindex="0">How to get</a></div><div class="telephone"><strong>Telephone: </strong><a href="tel:+18328310611">(832) 831-0611</a></div><div class="email"><strong>E-mail: </strong><a href="mailto:info@colvenusa.com">info@colvenusa.com</a></div></div>', 29.853986159723345, -95.41149368845207],
      ['<div><div class="name">Vectiority</div><div class="address"><strong>Address: </strong>3601 N Dixie Hwy, Unit 15, Boca Raton, Florida 33431<a target="_blank" href="https://www.google.com/maps/dir/?api=1&amp;destination=(26.383759263879774, -80.0823349711648)" tabindex="0">How to get</a></div><div class="telephone"><strong>Telephone: </strong><a href="tel:+15612458436">+1 (561) 245 8436 | 8904 | 8440</a></div><div class="email"><strong>E-mail: </strong><a href="mailto:info@vectiority.us">info@vectiority.us</a></div></div>', 26.383759263879774, -80.0823349711648],
      ['<div><div class="name">Big Boys Mechanic Shop</div><div class="address"><strong>Address: </strong>3445 Ellisville Blvd, Laurel, MS 39443<a target="_blank" href="https://www.google.com/maps/dir/?api=1&amp;destination=(31.643736633805066, -89.1774351182856)" tabindex="0">How to get</a></div><div class="telephone"><strong>Telephone: </strong><a href="tel:+16012589379">(601) 258-9379</a></div></div>', 31.643736633805066, -89.1774351182856],
      ['<div><div class="name">Jefe‘s Welding Co LLC</div><div class="address"><strong>Address: </strong>234 Co Rd 1171, Fairfield, TX 75840<a target="_blank" href="https://www.google.com/maps/dir/?api=1&amp;destination=(31.75120993109482, -96.20834617076454)" tabindex="0">How to get</a></div><div class="telephone"><strong>Telephone: </strong><a href="tel:+19033894036">(903) 389-4036</a></div></div>', 31.75120993109482, -96.20834617076454]
      /*
      ['<h4>Obama</h4><img src="https://cdn.pixabay.com/photo/2015/02/24/15/41/dog-647528__340.jpg" height="100" width="100">', -33.890542, 151.274856],
      ['<h4>Jared Leto</h4><img src="https://cdn.pixabay.com/photo/2015/02/24/15/41/dog-647528__340.jpg" height="100" width="100">', -33.923036, 151.259052],
      ['<h4>Amanda Palmer</h4><img src="http://amandapalmer.net/wp-content/uploads/2013/09/1173818_10151647707218375_1357447411_n-300x200.png" height="100" width="100">', 40.6451594,-74.0850828],
      ['<h4>Random Girl</h4><img src="https://s-media-cache-ak0.pinimg.com/originals/62/71/76/627176b115aee264d92f7a33df1137d9.jpg" height="100" width="100">', -33.80010128657071, 151.28747820854187],
      ['<h4>Old Man</h4><img src="https://cdn.pixabay.com/photo/2014/05/22/16/57/face-351281_960_720.jpg" height="100" width="100">', -33.950198, 101.259302],
      ['<h4>RadioHead </h4> <img src="http://i1.kym-cdn.com/entries/icons/original/000/018/291/radiohead.jpg" height="100" width="100">', 30.950198, 131.259302],
      ['<h4>Oview </h4> <img src="https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcRnD3tNAqzahr3RHZvGa5m-REBWzbt6lijC0fRA2wxfS0tHJUvvpA" height="100" width="100">', 52.3105386,4.7],
      ['<h4>Smile</h4><img src="https://cdn.pixabay.com/photo/2015/02/24/15/41/dog-647528__340.jpg" height="100" width="100">', -23.950198, 151.259302]
      */
    ];
    
    // Setup the different icons and shadows
    var iconURLPrefix = 'https://cdn.shopify.com/s/files/1/0225/2668/9360/t/11/assets/';
    
    var icons = [
      iconURLPrefix + 'colven-marker.png'
    ]
    var iconsLength = icons.length;

    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 4, // zoom inicial mapa
            maxZoom: 15, // zoom máximo
      center: new google.maps.LatLng(38.219139, -171.521267),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false, /* option for satelate view*/
      streetViewControl: false,
      panControl: false,
      styles: [{
                "stylers": [{
                    "saturation": -100
                }]
            }],
      zoomControlOptions: {
         position: google.maps.ControlPosition.LEFT_BOTTOM
      }
    }
                                 
                                 );

    
  

    var infowindow = new google.maps.InfoWindow({
      maxWidth: 205
    });

    var markers = new Array();
    var iconCounter = 0;
    
    // Add the markers and infowindows to the map
    for (var i = 0; i < locations.length; i++) {  
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        icon: icons[iconCounter]
      });

      markers.push(marker);

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(locations[i][0]);
          infowindow.open(map, marker);
        }
      })(marker, i));
      
      iconCounter++;
      // We only have a limited number of possible icon colors, so we may have to restart the counter
      if(iconCounter >= iconsLength) {
      	iconCounter = 0;
      }
    }

    function autoCenter() {
      //  Create a new viewpoint bound
      var bounds = new google.maps.LatLngBounds();
      //  Go through each...
      for (var i = 0; i < markers.length; i++) {  
				bounds.extend(markers[i].position);
      }
      //  Fit these bounds to the map
      map.fitBounds(bounds);
    }
    autoCenter();

  } catch(e) { console.error(e); }
})();
})();
